import { memo } from 'react';

import { PersonForm } from '~/src/features/full-buy/components/uiReactComponents/PersonForm';

import * as ST from './styled';

export type TField = {
    value: string,
    isValid: boolean,
    clearInput: () => void,
}

export type TContactDetailsProps = {
    title: string,
    fio: string,
    phone: string,
    isConfirmButtonActive?: boolean,
    btnText?: string,
    hideBtn?: boolean,
}

export type TContactDetailsCallbacks = {
    onFillFio: (fio: string) => void,
    onFillPhone: (phone: string) => void,
    onClick?: () => void,
}

const EditableContactsForm = ({
    title,
    fio,
    phone,
    isConfirmButtonActive,
    btnText,
    hideBtn,
    onFillFio,
    onFillPhone,
    onClick,
}: TContactDetailsProps & TContactDetailsCallbacks): JSX.Element => {
    return (
        <ST.EditableContactsForm>
            {title && <ST.BlockTitle>{title}</ST.BlockTitle>}
            <ST.BlockWrap>
                <PersonForm
                    fio={fio}
                    phone={phone}
                    onChangeFio={onFillFio}
                    onChangePhone={onFillPhone}
                    isNeedToBlockInvalidFio
                    actionButtonProps={!hideBtn
                        ? {
                            children: btnText || 'Продолжить',
                            onClick: onClick,
                            disabled: !isConfirmButtonActive,
                        }
                        : undefined
                    }
                />
            </ST.BlockWrap>
        </ST.EditableContactsForm>
    );
};

export default memo(EditableContactsForm);
